import React, { useState,useEffect } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Pagination, PaginationItem, Box
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useGetReferralInviteeListQuery } from "../../features/api/userApiSlice";
import { addDays ,format} from "date-fns";


const InviteeTable = ({startDate, endDate}) => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const { t } = useTranslation();

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const queryParams = { startDate, endDate };
  
    const { 
      data: inviteeList, 
      error, 
      isLoading,
      isFetching 
    } = useGetReferralInviteeListQuery(queryParams);
  
  const inviteeListResult = inviteeList?.result || [];

  const formattedInviteeList = inviteeListResult.map(apiItem => ({
  
    date: format(new Date(apiItem.dateCreated), 'dd-MM-yyyy'),
    referrerUsername: apiItem.referrerUsername,
    downlineUsername: apiItem.downlineUsername,
    downlineValidBet: apiItem.downlineValidBet,
    downlineDeposit: apiItem.downlineDeposit,
  }));

  const pageCount = Math.ceil(formattedInviteeList.length / rowsPerPage);

  const paginatedData = formattedInviteeList.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const summary = paginatedData.reduce(
    (acc, row) => ({
      downlineDeposit: acc.downlineDeposit + row.downlineDeposit,
      downlineValidBet: acc.downlineValidBet + row.downlineValidBet,
    }),
    { downlineDeposit: 0, downlineValidBet: 0 }
  );

  return (
    <Paper sx={{ backgroundColor: "white", mt: 4 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>{t("referral.registerdate")}</strong></TableCell>
              <TableCell><strong>{t("referral.referrerusername")}</strong></TableCell>
              <TableCell><strong>{t("referral.downlineusername")}</strong></TableCell>
              <TableCell align="center"><strong>{t("referral.targetdeposit")}</strong></TableCell>
              <TableCell align="center"><strong>{t("referral.targetvalidbet")}</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
           {paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("referral.norecords")}
                </TableCell>
              </TableRow>
            ) : (
              <>
                {paginatedData.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.referrerUsername}</TableCell>
                    <TableCell>{row.downlineUsername}</TableCell>
                    <TableCell align="center">{row.downlineDeposit.toLocaleString()}</TableCell>
                    <TableCell align="center">{row.downlineValidBet.toLocaleString()}</TableCell>
                  </TableRow>
                ))}
                    <TableRow>
                    <TableCell colSpan={2}><strong>Total Users : &nbsp;{paginatedData.length}</strong></TableCell>
                    </TableRow>
                    <TableRow>
                    <TableCell colSpan={3}><strong>Grand Total :</strong></TableCell>
                    <TableCell align="center"><strong>{summary.downlineDeposit.toLocaleString()}</strong></TableCell>
                    <TableCell align="center"><strong>{summary.downlineValidBet.toLocaleString()}</strong></TableCell>
                    <TableCell />
                    </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <Box display="flex" justifyContent="flex-end" py={2} pr={2}>
        <Pagination
          count={pageCount}
          page={page}
          onChange={handlePageChange}
          color="primary"
          siblingCount={1}        // max 1 sibling around the current page
          boundaryCount={1}       // show first and last page numbers
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{
                previous: ArrowBack,
                next: ArrowForward,
              }}
              sx={{
                '& svg': { color: 'black' }, // Make arrow icons black
              }}
            />
          )}
        />
      </Box>
    </Paper>
  );
};

export default InviteeTable;
